import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RequirePlayer({ children }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading' || status === 'idle') return null;
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Demo users get a single playable page (Round 1) and then the thank-you page.
  if (user.role === 'demobypass' && ['/round-2', '/round-3'].includes(location.pathname)) {
    return <Navigate to="/round-1" replace />;
  }

  const completed = sessionStorage.getItem('diwaliHuntCompleted') === '1';
  if (completed && location.pathname !== '/thankyou') {
    return <Navigate to="/thankyou" replace />;
  }

  return children;
}
